import { FilterIcon } from '../common/icons.jsx';

/**
 * Filter bar for client list: status, driver, city.
 * @param {{
 *   statusFilter: string, setStatusFilter: (v: string) => void,
 *   driverFilter: string, setDriverFilter: (v: string) => void,
 *   cityFilter: string, setCityFilter: (v: string) => void,
 *   drivers: Array, cities: string[]
 * }} props
 */
export default function ClientFilters({
  statusFilter, setStatusFilter,
  driverFilter, setDriverFilter,
  cityFilter, setCityFilter,
  drivers, cities,
}) {
  const selectCls = 'px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:ring-2 focus:ring-[var(--color-accent)] focus:border-[var(--color-accent)] focus:outline-none appearance-none cursor-pointer';

  return (
    <div className="flex gap-2 mb-4 flex-wrap items-center">
      <FilterIcon size={16} className="text-[var(--color-neutral)] shrink-0" />
      <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className={selectCls}>
        <option value="">Tous statuts</option>
        <option value="pending">En attente</option>
        <option value="in_progress">En cours</option>
        <option value="delivered">Livrés</option>
        <option value="problem">Problèmes</option>
      </select>

      <select value={driverFilter} onChange={(e) => setDriverFilter(e.target.value)} className={selectCls}>
        <option value="">Tous livreurs</option>
        {drivers.map((d) => (
          <option key={d.userId || d.id} value={d.userId || d.id}>{d.name || d.userName}</option>
        ))}
      </select>

      <select value={cityFilter} onChange={(e) => setCityFilter(e.target.value)} className={selectCls}>
        <option value="">Toutes villes</option>
        {cities.map((city) => (
          <option key={city} value={city}>{city}</option>
        ))}
      </select>
    </div>
  );
}
